import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AppConfigService} from "projects/nter-ui-kit/src/lib/framework/config/app-config.service";
import {lastValueFrom} from "rxjs";
import {ConsoleContextService} from "projects/soko-console-web-v2/src/app/security/console-context.service";
import {NavigationUtilsService} from "@ui-kit/framework/util/service/navigation-utils.service";

@Injectable({
  providedIn: 'root'
})
export class ConsoleAuthorizationService {
  private readonly environment: any;

  constructor(private http: HttpClient,
              private currentContext: ConsoleContextService,
              private _navUtils: NavigationUtilsService,
              config: AppConfigService) {
    this.environment = config.environment;
  }

  /**
   * Calls the local loadUserGrants() method as a synchronous call using a promise, waits on the response
   * and if successful, sets the user grants in the contextService using context.userGrants(grants[]);
   */
  public async refreshUserGrants(): Promise<void> {
    try {
      this.currentContext.userGrants = [await this.loadUserGrants()];
    } catch (error) {
      this.navigateToLoginAfterUnauthorizedAccess();
    }
  }

  public navigateToLoginAfterUnauthorizedAccess(): void {
    this.currentContext.reset(true);
    const message = 'You are not authorized to access this application. Please login with the correct credentials.';
    this._navUtils.navigateWithQueryParams('/login', message);
  }

  private loadUserGrants(): Promise<any> {
    return lastValueFrom(this.http.get(`${this.environment.apiSecurityHost}/console/rbac/user/location/features`));
  }
}
